import { createSlice } from '@reduxjs/toolkit';

import type { EscritorioConvitesState } from '@/types/escritorio/escritorioTypes';

import { cancelarConviteDoTenant, convidarParaTenant, listarConvitesDoTenant } from './actions';

const initialState: EscritorioConvitesState = {
  convites: [],
  isLoading: false,
  error: null,
};

const convitesTenantSlice = createSlice({
  name: 'convitesTenant',
  initialState,
  reducers: {
    limparConvitesDoTenant: (state) => {
      state.convites = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarConvitesDoTenant.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarConvitesDoTenant.fulfilled, (state, action) => {
        state.isLoading = false;
        state.convites = action.payload;
      })
      .addCase(listarConvitesDoTenant.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao listar convites do escritório';
      })

      .addCase(convidarParaTenant.fulfilled, (state, action) => {
        state.convites = [...action.payload.convites, ...state.convites];
      })
      .addCase(convidarParaTenant.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao enviar o convite';
      })

      .addCase(cancelarConviteDoTenant.fulfilled, (state, action) => {
        state.convites = state.convites.filter(
          (convite) => convite.id !== action.meta.arg.conviteId,
        );
      })
      .addCase(cancelarConviteDoTenant.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao cancelar o convite';
      });
  },
});

export const { limparConvitesDoTenant } = convitesTenantSlice.actions;
export const convitesTenantReducer = convitesTenantSlice.reducer;
